import React from 'react';

interface Logo7AsesProps {
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

export default function Logo7Ases({ height = 50, className, style }: Logo7AsesProps) {
  return (
    <img
      src="/images/logo-7ases.png"
      alt="7Ases Corretora de Seguros"
      className={className}
      style={{
        height: typeof height === 'number' ? `${height}px` : height,
        width: 'auto',
        objectFit: 'contain',
        ...style
      }}
    />
  );
}
